import { Component, Input } from '@angular/core';
import { JobDetail } from 'src/app/shared/models/gql/job-detail.model';

@Component({
  selector: 'app-client-flex-job-timeline',
  templateUrl: './client-flex-job-timeline.component.html',
  styleUrls: ['./client-flex-job-timeline.component.scss'],
})
export class ClientFlexJobTimelineComponent {
  @Input() bidCount = 0;

  @Input() job: JobDetail;
}
